export default function Loading() {
    const content = 'LOADING';

    return(
        <div className="cr-loading-page flex flex-wrap w-full h-[100vh]" id="cr-loading-page">
            <div className="loading-box w-full h-full">
                <div className="loading-text">
                    { content.split('').map((_, i)=>
                        <b key={`loading_${i}`}>{content[i]}</b>
                    )}
                </div>
            </div>
        </div>
    )
}